import React, { useEffect } from 'react'

const MergeCallback = () => {
  const params = new URLSearchParams(window.location.search)
  const success = params.get('success') === 'true'

  useEffect(() => {
    if (success) {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user) {
        user.hasGoogleAccountAssigned = true
        localStorage.setItem('social_merge_success', success)
        localStorage.setItem('social_merge_trigger', Date.now().toString())
        localStorage.setItem('user', JSON.stringify(user))
      }

      window.close()
    } else {
      localStorage.setItem('social_merge_success', success)
      localStorage.setItem('social_merge_trigger', Date.now().toString())
      window.close()
    }
  }, [success])

  return <div />
}

export default MergeCallback
